import React from "react";
import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import SessionQuantityInput from "./SessionQuantityInput";
import ToolTip from "app/routes/Scheduling/ToolTip";
import { useWindowWidth } from "app/utils/hooks/useWindowWidth";
import ButtonVariant from "app/components/Button/ButtonVariant";

const AutomaticTrackingSection = ({
  bookingOptions,
  setBookingOptions,
  setShowBookingModal,
  isPackage = false,
  submitAttempted,
}) => {
  const { t } = useTranslation();
  const windowWidth = useWindowWidth();
  const titleChars = windowWidth < 700 ? 5 : 10;

  if (bookingOptions.length === 0) {
    return (
      <div className={styles.booking_options_container}>
        <div className={styles.section_label_container}>
          <label className={styles.sectionLabel}>{t("Booking Options")}</label>
          {submitAttempted && (
            <div className={styles.error_text}>
              {t("Add at least one booking option to continue.")}
            </div>
          )}
        </div>
        <div className={styles.booking_box_empty}>
          <p className={styles.booking_subtext}>
            {t("You can add multiple booking options for this package")}
          </p>
          <div
            className={styles.add_btn_centered}
          >
            <ButtonVariant
              title={`+ ${t("Add Booking")}`}
              buttonType='primary-outline'
              onClickFunc={() => setShowBookingModal(true)}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.booking_options_container}>
      <label className={styles.sectionLabel}>{t("Booking Options")}</label>
      <div className={styles.booking_box}>
        <div className={styles.booking_list}>
          {bookingOptions.map((opt, index) => (
            <div key={index} className={styles.booking_item}>
              <div className={styles.booking_top}>
                <div className={styles.title_container}>
                  {opt.title?.length > titleChars ? <strong>{`${opt?.title?.substring(0, titleChars)}...`}</strong> : <strong>{opt.title}</strong>}
                  {opt.title?.length > titleChars && (
                    <div className={styles.toolTipPosition}>
                      <ToolTip text={opt.title} orientation="left" />
                    </div>
                  )}
                </div>
                <div className={styles.duration}>{opt.duration}</div>
                <div className={styles.button_component}>
                  <button
                    type="button"
                    className={styles.remove_icon}
                    onClick={() =>
                      setBookingOptions(bookingOptions.filter((_, i) => i !== index))
                    }
                  >
                    <i className="ico ico-x" />
                  </button>
                </div>
              </div>

              <div className={styles.booking_bottom}>
                {(() => {
                  const q = opt.quantity;
                  const isUnlimited = q === -1;
                  const displayQty = isUnlimited || q == null
                    ? 1
                    : Math.max(1, q);

                  return (
                    <SessionQuantityInput
                      quantity={displayQty}
                      isUnlimited={isUnlimited}
                      onChangeQuantity={(val) => {
                        const updated = [...bookingOptions];
                        updated[index].quantity = val;
                        setBookingOptions(updated);
                      }}
                      onToggleUnlimited={(checked) => {
                        const updated = [...bookingOptions];
                        updated[index].quantity = checked ? -1 : 1;
                        setBookingOptions(updated);
                      }}
                      label={t("Sessions Quantity")}
                      isPackage={isPackage}
                    />
                  );
                })()}
              </div>

            </div>
          ))}
        </div>

        <div
          className={styles.add_btn_wrapper}
        >
          <ButtonVariant
            title={`+ ${t("Add Booking")}`}
            buttonType='primary-outline'
            onClickFunc={() => setShowBookingModal(true)}
            buttonStyles={styles.add_booking_btn}
            childStyles={styles.add_booking_btn_text}
          />
        </div>
      </div>
    </div>
  );
};

export default AutomaticTrackingSection;
